import _ from "lodash"

export const getFileName = (path: string, fileName?: string) => {
  if (!_.isNil(fileName)) {
    return fileName
  }
  const str = _.split(path, "/")
  return _.last(str) ?? ""
}
